import { replace } from 'redux-first-history';
import { SagaIterator } from 'redux-saga';
import { PROJECT_LIST_SHARE } from 'src/modules/project-list/actions/ProjectListActions';
import { getProjectListQuery } from 'src/modules/project-list/selectors/getProjectListQuery';
import { buildProjectListQuery } from 'src/modules/project-list/utils/query';
import { navigate } from 'src/modules/routing/utils/navigate';
import {
  SHARE_PROJECT_CLOSE,
  SHARE_PROJECT_OPEN,
  SHARE_PROJECT_RELOAD_DATA,
} from 'src/modules/sharing-projects/actions/ShareProjectActions';
import { GetTriggerActionType } from 'src/utils/createTrigger';
import { call, put, select, take } from 'typed-redux-saga';

export function* projectListShareSaga(
  action: GetTriggerActionType<typeof PROJECT_LIST_SHARE>,
): SagaIterator<void> {
  const project = action.data;

  yield* put(SHARE_PROJECT_OPEN.trigger(project));

  yield* take([SHARE_PROJECT_RELOAD_DATA.is, SHARE_PROJECT_CLOSE.is]);

  yield* put(SHARE_PROJECT_CLOSE.trigger());

  const query = yield* select(getProjectListQuery);
  const search = yield* call(buildProjectListQuery, query);
  yield* call(navigate, replace({ pathname: '/projects', search: search.toString() }));
}
